'use client';

import { useEffect } from 'react';

import { Section, Title, TitleLevels, TrilogyColor } from '@bytel/trilogy-react';

import { logger } from '@services/loggers';

// import with @components => break server action basePath

type ErrorPageProps = { error: Error & { digest?: string }; reset: () => void };

function ErrorPage({ error }: Readonly<ErrorPageProps>) {
    useEffect(() => {
        logger.error(error);
    }, [error]);

    return (
        <Section backgroundColor={TrilogyColor.NEUTRAL_FADE}>
            <Title level={TitleLevels.ONE}>Oops, il y a une erreur !</Title>
        </Section>
    );
}

export default ErrorPage;
